// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".Expando_Expando__1p2E{grid-column:span 2}.Expando_content__2brZ{display:none;border:1px solid var(--color-gray)}.Expando_button__nQJF{border:none;background:rgba(0,0,0,0);cursor:pointer;padding:0}.Expando_open__3fZ3{display:block}", "",{"version":3,"sources":["app/components/Expando/Expando.css"],"names":[],"mappings":"AAAA,uBACI,kBAAA,CAGJ,uBACI,YAAA,CACA,kCAAA,CAGJ,sBACI,WAAA,CACA,wBAAA,CACA,cAAA,CACA,SAAA,CAGJ,oBACI,aAAA","file":"Expando.css","sourcesContent":[".Expando {\n    grid-column: span 2;\n}\n\n.content {\n    display: none;\n    border: 1px solid var(--color-gray);\n}\n\n.button {\n    border: none;\n    background: transparent;\n    cursor: pointer;\n    padding: 0;\n}\n\n.open {\n    display: block;\n}\n"]}]);
// Exports
exports.locals = {
	"Expando": "Expando_Expando__1p2E",
	"content": "Expando_content__2brZ",
	"button": "Expando_button__nQJF",
	"open": "Expando_open__3fZ3"
};
module.exports = exports;
